<div class="multi-line-select-dropdown-container {{ className }}" [ngClass]="{'show': isFocused, 'has-placeholder': hasPlaceholder}" [formGroup]="parentForm">
  <button (click)="onOpen()" type="button">{{ selectedValueText }}</button>

  <div class="select-dropdown-items">
    <ul>
      <li class="select-dropdown-item" *ngFor="let option of options; let i = index;">
        <a (click)="onItemSelect(i)">
          <span class='line-1'>{{ option.line1 }}</span><span class='line-2'>{{ option.line2 }}</span>
        </a>
      </li>
    </ul>
  </div>

  <select #input [formControlName]="name">
    <option *ngFor="let option of options; let i = index;"
            [value]="option.value"
            [selected]="option.value == selectedValue">
      {{ option.text }}
    </option>
  </select>
</div>
